import { sdk as imageClientSDK } from '@wix/image-kit';
export function getImageURL(_ref, targetWidth, targetHeight) {
  let {
    id,
    width,
    height
  } = _ref;
  return imageClientSDK.getScaleToFillImageURL(id, width, height, typeof targetWidth === 'number' ? targetWidth : parseInt(targetWidth, 10), typeof targetHeight === 'number' ? targetHeight : parseInt(targetHeight, 10));
}
//# sourceMappingURL=get-image-url.js.map